<script setup lang="ts">
const { toasts, dismiss } = useToast()
</script>

<template>
  <div class="toast-host">
    <transition-group name="toast">
      <div v-for="t in toasts" :key="t.id" class="toast" :class="t.kind" @click="dismiss(t.id)">
        {{ t.msg }}
      </div>
    </transition-group>
  </div>
</template>

<style scoped>
.toast-host {
  /* toasts must ALWAYS be visible (BB-947): z-300 tops every overlay — the chat fab
     (ChatOverlay .chat-mount z-130), the DFS draft sheet (z-135..140), and the
     body-teleported FilterTabs modal (z-200). Stacking alone isn't enough though:
     the fab is a 54px circle pinned at bottom 14-20px in the SAME corner, so the
     stack starts at bottom 84px to clear its top edge (74px desktop / 68px mobile)
     instead of the two fighting over the corner. */
  position: fixed; right: 16px; bottom: calc(84px + var(--bt-bottom-safe, 0px)); z-index: 300;
  display: flex; flex-direction: column; gap: 10px; max-width: min(360px, calc(100vw - 32px));
}
.toast {
  font-family: var(--font-mono); font-size: 13px; line-height: 1.4;
  padding: 12px 16px; border-radius: 10px; cursor: pointer;
  border: 1px solid var(--line); background: var(--panel-2, #221a49); color: var(--ink);
  box-shadow: 0 8px 24px rgba(0,0,0,0.4);
}
/* every variant's background must be an OPAQUE literal fallback: an undefined var()
   computes to the initial value (transparent), and the page then shows straight
   through the toast and swallows the text. `--accent-soft` never existed, which is
   exactly how the ok toast lost its background — it read as the page gradient behind
   it, so --panel-2 (what the other toasts already use) keeps that look, now opaque.
   the palette is unchanged: only the accent stays per-variant, in border + text. */
.toast.error { border-color: #5a2342; color: #ff9ab8; background: #2a1430; }
.toast.ok    { border-color: var(--accent); color: var(--accent); background: var(--panel-2, #221a49); }
.toast.info  { border-color: var(--line); color: var(--muted); background: var(--panel-2, #221a49); }
.toast-enter-from, .toast-leave-to { opacity: 0; transform: translateY(8px); }
.toast-enter-active, .toast-leave-active { transition: all .2s ease; }
</style>
